module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/theme-4-ff7f06f3b77ab7d9c0fe189548a4743e.webp";